import { render, staticRenderFns } from "./SuccessSplash.vue?vue&type=template&id=65853628&scoped=true&"
import script from "./SuccessSplash.vue?vue&type=script&lang=js&"
export * from "./SuccessSplash.vue?vue&type=script&lang=js&"
import style0 from "./SuccessSplash.vue?vue&type=style&index=0&id=65853628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65853628",
  null
  
)

export default component.exports